import React from 'react';
import { Smartphone, Map, Navigation, RefreshCcw, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const MobileApp = ({ onNavigate }) => {
  const features = [
    {
      icon: Map,
      title: "Carte Interactive",
      description: "Visualisez en temps réel toutes les bornes JYA disponibles autour de vous"
    },
    {
      icon: Navigation,
      title: "Itinéraire GPS",
      description: "Trouvez le chemin le plus rapide vers la borne la plus proche"
    },
    {
      icon: RefreshCcw,
      title: "Retour Flexible",
      description: "Déposez votre batterie dans n'importe quelle borne du réseau"
    },
    {
      icon: Smartphone,
      title: "Historique & Suivi",
      description: "Consultez vos locations et suivez votre consommation"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-1/2 h-full bg-gradient-to-r from-yellow-500/10 to-transparent" />
      <div className="absolute bottom-0 right-0 w-1/2 h-full bg-gradient-to-l from-green-500/10 to-transparent" />
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-6 py-2 bg-yellow-500 text-gray-900 rounded-full font-bold text-sm mb-6">
            <Smartphone className="w-4 h-4" />
            <span>APPLICATION MOBILE</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">
            Louez Ici, Retournez Là-Bas
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Grâce à notre application mobile, prenez une batterie à un endroit et déposez-la dans n'importe quelle borne JYA. Une vraie liberté de mouvement !
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div 
                key={index}
                className="bg-white/5 backdrop-blur-sm p-6 rounded-2xl border border-white/10 hover:border-yellow-500/50 hover:bg-white/10 transition-all duration-300"
              >
                <div className="w-12 h-12 bg-yellow-500/20 rounded-xl flex items-center justify-center mb-4">
                  <Icon className="w-6 h-6 text-yellow-400" />
                </div>
                
                <h3 className="text-lg font-bold mb-2">
                  {feature.title}
                </h3>
                
                <p className="text-gray-400 text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Visual representation */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 border border-white/10">
            <div className="grid md:grid-cols-3 gap-8 items-center">
              <div className="text-center">
                <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg shadow-green-500/50">
                  <Map className="w-10 h-10 text-white" />
                </div>
                <h4 className="font-bold mb-2">Prenez</h4>
                <p className="text-gray-400 text-sm">Louez à n'importe quelle borne</p>
              </div>
              
              <div className="hidden md:flex justify-center">
                <div className="flex gap-2">
                  <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse" />
                  <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }} />
                  <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }} />
                  <ArrowRight className="w-6 h-6 text-yellow-500" />
                  <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse" style={{ animationDelay: '0.6s' }} />
                  <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse" style={{ animationDelay: '0.8s' }} />
                  <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse" style={{ animationDelay: '1s' }} />
                </div>
              </div>
              
              <div className="text-center">
                <div className="w-20 h-20 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg shadow-yellow-500/50">
                  <RefreshCcw className="w-10 h-10 text-gray-900" />
                </div>
                <h4 className="font-bold mb-2">Retournez</h4>
                <p className="text-gray-400 text-sm">Déposez où vous voulez</p>
              </div>
            </div>
            
            <div className="mt-8 text-center">
              <p className="text-green-400 font-medium text-lg">
                ✓ Maximum de flexibilité pour vos déplacements
              </p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Button 
            size="lg"
            className="bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-bold text-lg px-10 py-6 rounded-xl shadow-2xl hover:shadow-yellow-500/50 transition-all duration-300 hover:scale-105"
            onClick={() => onNavigate('contact')}
          >
            Télécharger l'Application (Bientôt)
          </Button>
          <p className="text-gray-400 mt-4 text-sm">
            Application disponible sur iOS et Android
          </p>
        </div>
      </div>
    </section>
  );
};

export default MobileApp;
